import {UserResource} from "../resource/UserResource";
import {
    IApiUserShortProfile, IApiUserFullProfile, IApiUserBasicProfile, IApiUser,
    IApiPremiumAccountMap
} from "../typings/apiResponse";
import {User} from "../league/User";

export class UserService {

    public static $inject = ["UserResource"];
    constructor(private UserResource: UserResource) {}

    public getShortDescription(teamId: string, format?: string): angular.IPromise<string> {
        return this.UserResource.getShortDescription(teamId, format);
    }

    public getDescription(teamId: string, format?: string): angular.IPromise<string> {
        return this.UserResource.getDescription(teamId, format);
    }

    public getShortProfileForLoggedInUser(): angular.IPromise<IApiUserShortProfile> {
        return this.UserResource.getShortProfileForLoggedInUser();
    }

    public getFullProfileForLoggedInUser(): angular.IPromise<IApiUserFullProfile> {
        return this.UserResource.getFullProfileForLoggedInUser();
    }

    public getBasicProfileForLoggedInUser(): angular.IPromise<IApiUserBasicProfile> {
        return this.UserResource.getBasicProfileForLoggedInUser();
    }

    public getUsers(userIds: string[], fields?: string[]): angular.IPromise<User[]> {
        return this.UserResource.getUsers(userIds, fields)
            .then((apiUsers: IApiUser[]) => {
                return apiUsers.map(apiUser => new User(apiUser));
            });
    }

    public getPremiumUntilForLoggedInUser(): angular.IPromise<Date> {
        return this.UserResource.getPremiumDaysForLoggedInUser()
            .then((premiumAccountMap: IApiPremiumAccountMap) => {
                const premiumDays = premiumAccountMap["default"] ? premiumAccountMap["default"].pd : -1;
                const dayUntilExpired = new Date();

                if (!premiumDays) {
                    return null;
                }

                dayUntilExpired.setDate(dayUntilExpired.getDate() + premiumDays);

                return dayUntilExpired;
        });
    }
}
